import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, Query } from '@angular/fire/firestore';
import { switchMap, take } from 'rxjs/operators';
import * as firebase from 'firebase';
import { Survey, SurveyQuestion } from '@app/interface/survey';
import { FirebaseAuthService } from './firebaseauth.service';
import { UserDetail } from '@app/interface/auth.user';
import { StudiesService } from './studies.service';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SurveyService {
  constructor(
    private store: AngularFirestore,
    private afAuth: AngularFireAuth,
    private authService: FirebaseAuthService,
    private studiesService: StudiesService
  ) {}

  public addSurvey(survey: Survey, studyDetail: any) {
    return this.authService.getUser().pipe(
      switchMap((user: UserDetail) => {
        survey.uuid = this.store.createId();
        survey.createdBy = user.role;
        survey.createdByuserId = user.uuid;
        survey.studyName = studyDetail.studyName;
        survey.studyRef = studyDetail.docRef;
        survey.studyId = studyDetail.uuid;
        survey.createdAt = firebase.default.firestore.Timestamp.now();
        survey.isDelete = false;
        return this.store.collection<Survey>('surveys').doc(survey.uuid).set(survey, { merge: true });
      })
    );
  }

  public updateSurvey(survey: Survey) {
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.default.User) => {
        survey.updatedAt = firebase.default.firestore.Timestamp.now();
        return this.store.collection<Survey>('surveys').doc(survey.uuid).update(survey);
      })
    );
  }

  public getSurveys(studyName: string) {
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.default.User) => {
        return this.store
          .collection<Survey>('surveys', (ref) => {
            let query: Query = ref;
            return query.where('studyName', '==', studyName).orderBy('createdAt', 'desc');
          })
          .valueChanges();
      })
    );
  }

  public getSurveyQuestions(surveyUUID: string) {
    return this.store.collection<SurveyQuestion>('surveys').doc(surveyUUID).collection('questions').valueChanges();
  }

  public getSurveysByStudyId() {
    let studyId = this.studiesService.getStudyId();
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.default.User) => {
        if (user && studyId) {
          return this.store
            .collection<Survey>('surveys', (ref) => {
              let query: Query = ref;
              return query.where('studyId', '==', studyId).where('isDelete', '==', false).orderBy('createdAt', 'desc');
            })
            .valueChanges();
        } else {
          return of([]);
        }
      })
    );
  }
}
